<template>
  <div class="w-full h-full relative">
    <GImage style="object-fit: contain; width: 100%; height: 100%" :src="cover">
      <template #placeholder>
        <div class="image-slot">
          <SvgIcon name="image-placeholdLogo" style="max-width: 50%" />
        </div>
      </template>
      <template #fallback>
        <div class="image-slot">
          <SvgIcon name="image-placeholdLogo" style="max-width: 50%" />
        </div>
      </template>
    </GImage>
    <div class="playBtn" @click="playing = !playing">
      <img :src="playing ? pauseIcon : playIcon" alt="" />
    </div>
  </div>
  <audio ref="audioRef" class="hidden" :src="audioSrc" />
  <Teleport to="#news-article-audio">
    <div class="bottom-play-box">
      <div class="c-container box">
        <div class="w-42px h-32px rounded-1px overflow-hidden">
          <GImage style="object-fit: contain; width: 100%; height: 100%" :src="cover">
            <template #placeholder>
              <div class="image-slot">
                <SvgIcon name="image-placeholdLogo" style="max-width: 50%" />
              </div>
            </template>
            <template #fallback>
              <div class="image-slot">
                <SvgIcon name="image-placeholdLogo" style="max-width: 50%" />
              </div>
            </template>
          </GImage>
        </div>
        <img
          @click="playing = !playing"
          class="w-30px h-30px cursor-pointer mx-16px"
          :src="playing ? pauseFullIcon : playFullIcon"
          alt=""
        />
        <div class="flex flex-col w-638px">
          <div
            class="text-font-bold font-500 text-12px color-#fff leading-14px mb-4px text-hidden-1"
          >
            {{ title }}
          </div>
          <div class="flex items-center gap-12px">
            <NSlider
              style="flex: 1"
              v-model:value="progress"
              :tooltip="false"
              class="slider"
              :on-update:value="updateTime"
              :on-dragstart="dragStart"
              :on-dragend="dragEnd"
            >
              <template #thumb>
                <div class="w-8px h-6px bg-#fff"></div>
              </template>
            </NSlider>
            <div class="flex items-center text-font-bold text-10px color-#fff">
              <span>
                {{ formatDuraton(showCurrentTime || 0, true) }}
              </span>
              &nbsp;
              <span class="color-#FFFFFF80"> / {{ formatDuraton(totalDuration || 0, true) }} </span>
            </div>
          </div>
        </div>
        <img
          @click="changeVolume"
          class="w-24px h-24px cursor-pointer ml-24px"
          :src="volume === 0 ? closeVolumnIcon : volumnIcon"
          alt=""
        />
      </div>
    </div>
  </Teleport>
</template>
<script setup lang="ts">
import { useStore } from '@gx-vuex'
import playIcon from '@/assets/audio/play-icon.png'
import pauseIcon from '@/assets/audio/pause-icon.png'
import playFullIcon from '@/assets/audio/play-full-icon.png'
import pauseFullIcon from '@/assets/audio/pause-full-icon.png'
import volumnIcon from '@/assets/audio/volumn-icon.png'
import closeVolumnIcon from '@/assets/audio/close-volumn-icon.png'
import { useMediaControls } from '@vueuse/core'
import GImage from '@/components/GImage'
import { formatDuraton } from '@/utils/util'
import useAudio from '@/hooks/web/useAudio'

const store = useStore()
const { pause } = useAudio()

const title = document.querySelector('.c-title').innerHTML
const playBoxDom = document.querySelector('#playBox')

const cover = playBoxDom.getAttribute('data-cover')
const audioSrc = playBoxDom.getAttribute('data-src')

const audioRef = ref()

const { playing, currentTime, duration, volume, waiting } = useMediaControls(audioRef)

const progress = ref(0)

const totalDuration = computed(() => {
  return duration.value || Number(playBoxDom.getAttribute('data-duration'))
})

let canSeek = true
const showCurrentTime = ref(0)
const dragStart = () => {
  canSeek = false
}

const dragEnd = () => {
  canSeek = true
  updateTime(progress.value)
}

const updateTime = (val: number) => {
  const playTime = totalDuration.value * (val / 100)
  if (canSeek) {
    currentTime.value = playTime
  }
  showCurrentTime.value = playTime
  progress.value = val
}

watch(currentTime, (val) => {
  if (canSeek) {
    progress.value = (val / totalDuration.value) * 100
    showCurrentTime.value = val
  }
})

const changeVolume = () => {
  if (volume.value === 0) volume.value = 1
  else if (volume.value === 1) volume.value = 0
}

watch(
  () => store.global.articleAudioPlayStatus,
  (val) => {
    if (val) {
      playing.value = false
    }
  }
)

watch(playing, (val) => {
  if (val) {
    pause()
  }
})
</script>

<style lang="less" scoped>
.playBtn {
  --at-apply: w-48px h-48px overflow-hidden absolute z-1 cursor-pointer flex items-center
    justify-center;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.4);
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  img {
    width: 24px;
    height: 24px;
  }
}

.bottom-play-box {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 52px;
  background: linear-gradient(180deg, rgba(64, 64, 76, 0.8) 0%, #3a3a3a 0%, #040404 100%);
  z-index: 1000;
  .box {
    height: 100%;
    display: flex;
    align-items: center;
    :deep(.slider) {
      .n-slider-rail {
        height: 2px !important;
        background-color: #3d3d3d !important;
        .n-slider-rail__fill {
          background-color: #ed2800 !important;
        }
      }
      .n-slider-handles {
        left: 4px !important;
        right: 0 !important;
      }
    }
  }
}
</style>
